// src/hooks/useVideoLoader.ts
import { useEffect, useState, useCallback } from "react";
import { getStoredTokens } from "services/config/axios.config";

/**
 * Hook para cargar un video desde backend con validación previa.
 * Usa HEAD al endpoint /videos/:id/stream para validar que existe y es accesible.
 * No dispara Toasts, solo devuelve estados para que el componente decida qué mostrar.
 */
export const useVideoLoader = (videoId?: string) => {
  const [mediaUrl, setMediaUrl] = useState<string | null>(null);
  const [videoLoading, setVideoLoading] = useState<boolean>(false);
  const [videoError, setVideoError] = useState<string | null>(null);

  const loadVideo = useCallback(async () => {
    if (!videoId) return;

    setVideoLoading(true);
    setVideoError(null);
    setMediaUrl(null);

    try {
      // Perfil del usuario (para Company-ID si aplica)
      const userProfile = JSON.parse(localStorage.getItem("userProfile") || "{}");
      const companyId = userProfile?.companyId || 1;
      const token = await getStoredTokens().token;
      console.log(token)

      // Base URL (con fallback a localhost)
      const API_BASE_URL =
        process.env.REACT_APP_BASE_URL || "http://localhost:8080";
      const directUrl = `${API_BASE_URL}/videos/${videoId}/stream`;

      // HEAD request para validar disponibilidad
      const response = await fetch(directUrl, {
        method: "HEAD",
        headers: {
          "Company-ID": companyId.toString(),
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) throw new Error("No se pudo validar el video");

      setMediaUrl(directUrl);
    } catch (error) {
      console.error("Error al validar video:", error);
      setVideoError("No se pudo cargar el video.");
    } finally {
      setVideoLoading(false);
    }
  }, [videoId]);

  useEffect(() => {
    if (videoId) loadVideo();
  }, [videoId, loadVideo]);

  return {
    mediaUrl,
    videoLoading,
    videoError,
    reloadVideo: loadVideo,
  };
};
